import React, { FC } from 'react';

import { Icon, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'common/components';
import { ButtonVariant, MessageType, ModalSize } from 'common/enums';
import { actionIcCheckCircle24px, alertIcError24px, alertIcWarning24px } from 'assets/media/icons';

import './MessageModal.scss';

type MessageModalProps = {
    headerName?: string;
    message?: string;
    primaryButton?: string;
    secondaryButton?: string;
    isVisible: boolean;
    type?: number;
    isSecondaryButtonVisible?: boolean;
    toolTip?: string;
    isCloseButtonHidden?: boolean;
    onPrimaryAction: () => void;
    onSecondaryAction?: () => void;
};

const MessageModal: FC<MessageModalProps> = ({
    headerName,
    message,
    primaryButton,
    secondaryButton,
    isVisible,
    type,
    isSecondaryButtonVisible,
    toolTip,
    isCloseButtonHidden,
    onPrimaryAction,
    onSecondaryAction
}) => {
    return (
        <Modal
            className="popup-modal"
            size={ModalSize.Large}
            show={isVisible}
            onClose={onSecondaryAction}>
            <ModalHeader className={`header ${isCloseButtonHidden && 'close-button-hidden'}`}>
                {headerName}
            </ModalHeader>
            <ModalBody className="border-bottom-line">
                <div>
                    <div className="inner-body-content">
                        {type === MessageType.Success ? (
                            <Icon className="success-icon" src={actionIcCheckCircle24px} />
                        ) : type === MessageType.Error ? (
                            <Icon className="error-icon" src={alertIcError24px} />
                        ) : (
                            <Icon className="warning-icon" src={alertIcWarning24px} />
                        )}
                        <span className="content" title={toolTip}>
                            {message}
                        </span>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    variant={ButtonVariant.Primary}
                    className="action-button"
                    onClick={onPrimaryAction}>
                    {primaryButton}
                </Button>
                {isSecondaryButtonVisible && (
                    <Button
                        variant={ButtonVariant.Secondary}
                        className="action-button"
                        onClick={onSecondaryAction}>
                        {secondaryButton}
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default MessageModal;
